<div>
    <p-dropdown 
        [options]="reels" 
        [(ngModel)]="selectedReel" 
        optionLabel="name"
        optionValue="id"
        placeholder="Seleccione el Reel para importar"
        emptyMessage="No existen Reels para importar"
        >
    </p-dropdown>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!selectedReel"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
